export default __webpack_public_path__ + "static/2-66d0e34b106e2cad4e4fe390e8aaa6c4.jpeg";